import UserActions from './UserActions';
import resolveUserActions from './resolveUserActions';
import StoreName from '../Shared/Constants/StoreName';

const createUserActionsStore = state =>
    state.createStore({
        name: StoreName.USER_ACTIONS,
        model: UserActions,
        actions: resolveUserActions,
    });

export default createUserActionsStore;
